import React from 'react';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60" onClick={onClose} data-id="element-377">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col" onClick={e => e.stopPropagation()} data-id="element-378">
        <div className="flex items-center justify-between p-4 border-b border-gray-200" data-id="element-379">
          <h2 className="text-lg font-bold text-[#2C3E50]" data-id="element-380">{title}</h2>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-100 transition-colors" data-id="element-381">
            <XIcon className="w-5 h-5 text-gray-500" data-id="element-382" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto text-sm text-gray-700 leading-relaxed space-y-4" data-id="element-383">
          {children}
        </div>
      </div>
    </div>;
}